<div class="main-container">

    <div class="mb-5">
        {{ 'nav_bar_menu_payment' | translate }}
    </div>
</div>